module.exports = __webpack_public_path__ + "orange-tick.png?effc4e519649a31abd869d4b0b662ac5";